import useFetchValidPayment from 'Hooks/useFetchValidPayment';
import serializeMerchantData from 'Utils/serializeMerchantData';

export const usePaymentLogin = () => {
  const fetchValidPayment = useFetchValidPayment();

  async function getPaymentData() {
    const payment = await fetchValidPayment();
    if (!payment || !payment.valid) return null;

    return serializeMerchantData(payment);
  }

  return {
    getPaymentData,
  };
};
